// Country-wise mobile number rules (length + valid starting digits) from libphonenumber-js.
// The "/mobile" build only accepts MOBILE numbers (landlines fail), which is what WhatsApp needs.
import {
  isValidPhoneNumber,
  isSupportedCountry,
  getCountryCallingCode,
  getExampleNumber,
} from 'libphonenumber-js/mobile';
import examples from 'libphonenumber-js/mobile/examples';

// `country` = { iso, dial } from countries.js, `digits` = number typed after the code.
// The full "+<dial><digits>" is checked, so codes like +1268 (Antigua) also work.
export const isValidMobile = (country, digits) => {
  const iso = country.iso.toUpperCase();
  if (!isSupportedCountry(iso)) return digits.length >= 6; // fallback: basic length check
  return isValidPhoneNumber(`+${country.dial}${digits}`, iso);
};

// Example mobile number for the placeholder / error message, e.g. "712345678" for Tanzania
export const exampleMobile = (country) => {
  const iso = country.iso.toUpperCase();
  if (!isSupportedCountry(iso)) return '';
  const example = getExampleNumber(iso, examples);
  if (!example) return '';
  // For +1xxx countries the area code is already part of our dial code, so drop it
  const extra = country.dial.slice(getCountryCallingCode(iso).length);
  const national = example.nationalNumber;
  return national.startsWith(extra) ? national.slice(extra.length) : national;
};
